// Position bubble colours: P1 blue, P2 green, P3 orange, P4 violet, P5 red, ...
// Each prefix ("B P1", "A P1") gets its own shifted sequence, so "B P1" differs from "P1".
export const POS_PALETTE = ["#2563eb", "#16a34a", "#f97316", "#9333ea", "#dc2626", "#0891b2", "#db2777", "#65a30d", "#ca8a04", "#4f46e5",
    "#0d9488", "#7c3aed", "#0284c7", "#e11d48", "#15803d", "#c2410c", "#a21caf", "#4d7c0f", "#b45309", "#1d4ed8"];

const hash = (s) => [...s].reduce((h, ch) => (h * 31 + ch.charCodeAt(0)) >>> 0, 7);

function parseLabel(label) {
    const s = String(label || "").trim();
    const m = s.match(/^(.*?)P\s*(\d+)\s*$/i);
    return m ? { prefix: m[1].trim().toUpperCase(), num: parseInt(m[2], 10) } : { prefix: s.toUpperCase(), num: 0 };
}

function prefIndex(label) {
    const n = POS_PALETTE.length;
    const { prefix, num } = parseLabel(label);
    if (!num) return hash(prefix) % n;
    const shift = prefix ? (hash(prefix) % (n - 1)) + 1 : 0;
    return (num - 1 + shift) % n;
}

export const colorMode = (tray) => tray?.color_mode || (tray?.bubble_color ? "uniform" : "position");

export function sortLabels(labels) {
    return [...new Set(labels.filter(Boolean))].sort((a, b) => {
        const A = parseLabel(a), B = parseLabel(b);
        return A.prefix.localeCompare(B.prefix) || A.num - B.num || a.localeCompare(b);
    });
}

// label -> hex. Manual colours are reserved first; the rest take their preferred colour or the next free one.
export function assignPosColors(labels, manual = {}) {
    const out = {};
    const used = new Set();
    const list = sortLabels(labels);
    list.forEach((l) => { if (manual[l]) { out[l] = manual[l]; used.add(manual[l].toLowerCase()); } });
    const n = POS_PALETTE.length;
    list.forEach((l) => {
        if (out[l]) return;
        const p = prefIndex(l);
        let hex = POS_PALETTE[p];
        for (let k = 0; k < n; k++) {
            const c = POS_PALETTE[(p + k) % n];
            if (!used.has(c)) { hex = c; break; }
        }
        out[l] = hex;
        used.add(hex);
    });
    return out;
}

export function rgba(hex, a = 1) {
    const s = String(hex || "#000000").replace("#", "");
    const [r, g, b] = [0, 2, 4].map((i) => parseInt(s.slice(i, i + 2), 16) || 0);
    return `rgba(${r},${g},${b},${a})`;
}
